import { ApplicationState } from '../../../../../store';
import { InputFieldConfig } from '../../../../../types';
import { IPersonalInfo } from 'types';
import { Fields, Visible, getPageStatus } from './index';

export const selectPage1Data = (
  state: ApplicationState,
): {
  givenNameConfig: InputFieldConfig;
  middleNameConfig: InputFieldConfig;
  surnameConfig: InputFieldConfig;
  hasOtherNamesConfig: InputFieldConfig;
  otherNameSurnameConfig: InputFieldConfig;
  otherNameGivenNameConfig: InputFieldConfig;
  otherNameReasonConfig: InputFieldConfig;
} => {
  const {
    GivenName: givenNameConfig,
    MiddleName: middleNameConfig,
    FamilyName: surnameConfig,
    HasOtherNames: hasOtherNamesConfig,
    OtherNameFamilyName: otherNameSurnameConfig,
    OtherNameGivenName: otherNameGivenNameConfig,
    OtherNameReason: otherNameReasonConfig,
  }: {
    GivenName: InputFieldConfig;
    MiddleName: InputFieldConfig;
    FamilyName: InputFieldConfig;
    HasOtherNames: InputFieldConfig;
    OtherNameFamilyName: InputFieldConfig;
    OtherNameGivenName: InputFieldConfig;
    OtherNameReason: InputFieldConfig;
  } = state.student.config.Checklist.PersonalInfo.Page1;

  return {
    givenNameConfig,
    middleNameConfig,
    surnameConfig,
    hasOtherNamesConfig,
    otherNameSurnameConfig,
    otherNameGivenNameConfig,
    otherNameReasonConfig,
  };
};

export const selectPersonalInfo = (state: ApplicationState): Partial<IPersonalInfo> => {
  const { surname, middleName, givenName, hasOtherNames, otherNames } = state.student.personalInfo;

  return {
    surname,
    middleName,
    givenName,
    hasOtherNames,
    otherNames,
  };
};

export const selectPageStatus =
  (fields: Fields) =>
  (state: ApplicationState): { complete: boolean; visible: Visible } => {
    const { complete, visible } = getPageStatus(
      state.student.config,
      {
        ...fields,
      },
      state.student.importData,
    );

    return {
      complete,
      visible,
    };
  };
